export default defineNuxtRouteMiddleware(async (to) => {
  // Только на сервере
  if (process.client) return;

  const ctx = useEntryContext();

  // Для startapp используем готовый redirectUrl
  if (ctx?.source === "startapp" && ctx?.redirectUrl) {
    return navigateTo(ctx.redirectUrl, { external: true });
  }

  // Для остальных случаев
  if (!ctx.project) return;

  const { appRoutes } = await import("~/lib/appRegistry");
  const app = (ctx.app ?? "crm") as "main" | "crm";
  const targetUrl = appRoutes[app](ctx.project, ctx.path);

  const isAbsolute = /^https?:\/\//i.test(targetUrl);

  if (isAbsolute) {
    return navigateTo(targetUrl, { external: true });
  }
});
